// @flow
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

type Props = {
  isOpen: boolean,
  onClose: () => void,
  url: string,
};

export function DonationOverlay({ isOpen, onClose, url }: Props): React$Node {
  const [iframeUrl, setIframeUrl] = useState('');

  useEffect(() => {
    if (isOpen) {
      const originalOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';

      const href = new URL(url);
      if (!href.pathname.endsWith('/overlay/')) {
        href.pathname = href.pathname.replace(/\/$/, '') + '/overlay/';
      }
      setIframeUrl(href.toString());

      return () => {
        document.documentElement.style.overflow = originalOverflow;
      };
    }
  }, [isOpen, url]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data === 'close-rgive-overlay') {
        onClose();
      } else if (event.data === 'rgive-form-loaded') {
        const iframe = document.getElementById('donation-overlay-iframe');
        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.postMessage({ parentUrl: window.location.href }, event.origin);
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [onClose]);

  if (!isOpen) return null;

  return createPortal(
    <iframe
      id="donation-overlay-iframe"
      src={ iframeUrl }
      allow="payment *; sync-xhr *"
      allowFullScreen
      style={ {
        position: 'fixed',
        display: 'block',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        margin: 0,
        padding: 0,
        border: 'none',
        overflowX: 'hidden',
        overflowY: 'auto',
        visibility: 'visible',
        backgroundColor: 'transparent',
        zIndex: 2147483647,
      } }
    />,
    document.body,
  );
}
